import { render } from "./DeliveryInputData.vue?vue&type=template&id=436801b8&scoped=true&ts=true"
import script from "./DeliveryInputData.vue?vue&type=script&lang=ts"
export * from "./DeliveryInputData.vue?vue&type=script&lang=ts"

import "./DeliveryInputData.vue?vue&type=style&index=0&id=436801b8&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436801b8"]])

export default __exports__